import { cn } from '#/lib/utils';
import { Link } from '#/components/Link';

type Props = {
  filters: {
    _key: string;
    href: string;
    title: string;
    isActive: boolean;
  }[];
};

export function ListingFilters(props: Props) {
  if (props.filters.length <= 1) return null;

  return (
    <div className="no-scrollbar bleed l:no-bleed flex gap-x-20 overflow-x-auto whitespace-nowrap border-b-1 border-grayscale-02 px-15 l:block l:space-y-20 l:border-b-0 l:px-0">
      {props.filters.map((filter) => (
        <Link
          key={filter._key}
          href={filter.href}
          className={cn(
            'block py-20 text-14 font-[440] leading-110 transition-colors l:py-0',
            filter.isActive
              ? 'text-charcoal'
              : 'text-grayscale-04 hover:text-charcoal',
          )}
        >
          {filter.title}
        </Link>
      ))}
    </div>
  );
}
